import React, {useContext, useState} from 'react';
import __ from "lodash";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TemplateSelectDialogValidator from "../validators/TemplateSelectDialogValidator";
import SystemContext from "../../../SystemContext";
import {ComboSelect, LabelledPaper, RadioButtonGroup} from "../../../controls";
import {FormGroup, useTheme} from '@material-ui/core';
import EnquiryCostingSelector from './EnquiryCostingSelector';


const enquiryTypeRadioButtons = [
  {label: "Generic", value: "GENERIC", disabled: false, size: "small"},
  {label: "Live Animals", value: "AVI", disabled: false, size: "small"},
  {label: "Vehicles", value: "VEHICLES", disabled: false, size: "small"},
];

const TemplateSelectionDialog = (props) => {
  const SystemData = useContext(SystemContext);
  const theme = useTheme();

  const [template, setTemplate] = useState(null);
  const [templateType, setTemplateType] = useState(null);
  const [costingUuid, setCostingUuid] = useState(null);

  const [validationState, setValidationStatus] = useState({
    error: true,
    errorMessage: "checking",
    field: null
  });

  const handleClose = () => {
    setTemplate(null);
    setTemplateType(null);
    setCostingUuid(null);
    if (props.onChange)
      props.onChange(null, null);
  };

  const handleSave = () => {
    if (props.onChange && template)
      props.onChange(template, templateType, costingUuid);
    else
      props.onChange(null, null);
    setTemplate(null);
    setTemplateType(null);
    setCostingUuid(null);
  };


  if (props.open){
    return (
      <div id={"SelectACustomerDialog"}>
        <Dialog open={props.open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                disableBackdropClick={true}
        >
          <DialogTitle id="form-dialog-title">
            <div style={{clear: "both", backgroundColor:theme.palette.primary.main, padding:"10px"}}>
              Quote Template Selection
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {`Please select the required template for the quote`} <br/><br/>
            </DialogContentText>
            <div>
              <ComboSelect
                id="template"
                label="Template"
                inputLabelProps={{shrink: true}}
                value={""}
                group="ENQUIRIES"
                subGroup="QUOTE"
                fullWidth
                returnType={"objectOnly"}
                onChange={(returnObject) => {
                  if (returnObject && !__.isEmpty(returnObject)) {
                    setTemplate(returnObject.data);
                  }
                }}
              />
            </div>
            <LabelledPaper label="Quote Type" style={{marginTop: 30, marginBottom: 15}}>
              <FormGroup key="FG-enquiryTypeRadioButton" style={{padding: "0px 8px 0px 8px"}}>
                <RadioButtonGroup
                  value={templateType}
                  key="RBG-enquiryTypeRadioButtons"
                  buttons={enquiryTypeRadioButtons}
                  onChange={(value, props) => {
                    setTemplateType(value);
                  }}
                />
              </FormGroup>
            </LabelledPaper>
            <EnquiryCostingSelector
              label="Costing"
              shrink={true}
              fullWidth={true}
              id="costingUuid"
              value={costingUuid}
              enquiryUuid={props.enquiryUuid} 
              returnType={"object"}
              onChange={(costingObject) => {
                if (costingObject && typeof costingObject === "object") {
                  setCostingUuid(costingObject.value);
                }  
              }}
            />
            <TemplateSelectDialogValidator
              template={template}
              templateType={templateType}
              costingUuid={costingUuid}
              onChange={(validation) => {
                setTimeout(()=> {
                  setValidationStatus(validation);
                },1);
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSave} disabled={validationState.error || !template} color="primary">
              Select
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  } else {
    return (<></>);
  }
}

export default TemplateSelectionDialog;
